import { createSelector } from 'reselect';
import { RootState } from '../../core/store';
import { IFilterSearchForm, IOwnershipSearchForm, IPortfolioSearchForm, IVesselSearchForm, ISectorSearchForm } from './searchTypes';
import { selectIsSubscriptionDataFetched, selectSubscribedMsiOwnerships, selectSubscribedMsiVessels, selectSubscribedSectors } from '../../user-management/appSelectors';
import { ISelectedVesselsFormData } from '../../shared/sharedTypes';


//from portfolio slice
export const selectPortfolioSearchFormData = createSelector(
    [(state: RootState) => state.portfolioSlice],
    (portfolioSlice) => portfolioSlice.portfolios.map((p) => ({ id: p.id, name: p.name, scope: p.scope, isOwnPortfolio: p.isOwnPortfolio })) as IPortfolioSearchForm[]);

export const selectIsFetchedPortfolios = createSelector(
    [(state: RootState) => state.portfolioSlice],
    (portfolioSlice) => portfolioSlice.isFetched as boolean);


//from filter slice
export const selectFilterSearchFormData = createSelector(
    [(state: RootState) => state.filterSlice],
    (filterSlice) => filterSlice.filters.map((p) => ({ id: p.id, name: p.name, scope: p.scope, isOwnFilter: p.isOwnFilter })) as IFilterSearchForm[]);

export const selectIsFetchedFilters = createSelector(
    [(state: RootState) => state.filterSlice],
    (filterSlice) => filterSlice.isFetched as boolean);


// from subscription slice
export const selectSubscribedVesselSearchFormData = createSelector(
    [selectSubscribedMsiVessels],
    (subscribedMsiVessels) => subscribedMsiVessels.map((v) => ({ imoNumber: v.imoNumber, name: v.vesselName, sector: v.sectorName, companyName: v.owner })) as IVesselSearchForm[]);

export const selectSubscribedOwnershipSearchFormData = createSelector(
    [selectSubscribedMsiOwnerships],
    (subscribedMsiOwnerships) => subscribedMsiOwnerships.map(companyName => ({ name: companyName })) as IOwnershipSearchForm[]);

export const selectSubscribedSectorSearchFormData = createSelector(
        [selectSubscribedSectors],
        (subscribedSectors) => subscribedSectors.map(s => ({ name: s.sectorName })) as ISectorSearchForm[]);
        
// Subscribed vessel data is loaded depending on selected subscription
export const selectIsFetchedSubscribedMsiVessels = createSelector(
    [selectIsSubscriptionDataFetched],
    (isSubscriptionDataFetched) => isSubscriptionDataFetched as boolean);

export const selectSelectionData = createSelector(
    [(state: RootState) => state.searchSlice],
    (searchSlice) => {
        return ({ selectedVesselsList: searchSlice.selectedVesselsList, outputType: searchSlice.outputType, selectionType: searchSlice.selectionType, selectionName: searchSlice.selectionName, selectionTypeObject: searchSlice.selectionTypeObject }) as ISelectedVesselsFormData
    });


